import React from 'react';
import { Link } from 'react-router-dom';
import GalagoLogo from '../components/GalagoLogo';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-[#0B1020] text-white">
      <div className="mx-auto max-w-4xl px-6 py-10 sm:px-10">
        <div className="flex items-center justify-between gap-4 border-b border-white/10 pb-6">
          <Link to="/" className="flex items-center gap-3">
            <GalagoLogo size={28} />
            <span className="text-lg font-bold tracking-wide">GalaGo</span>
          </Link>
          <Link to="/" className="text-sm text-white/60 hover:text-white transition-colors">
            Back to home
          </Link>
        </div>

        <main className="py-10">
          <p className="text-sm uppercase tracking-[0.2em] text-[#FFD93D]">Legal</p>
          <h1 className="mt-3 text-4xl font-black tracking-tight sm:text-5xl">Privacy Policy</h1>
          <p className="mt-4 text-sm text-white/50">Effective date: April 14, 2026</p>

          <div className="mt-10 space-y-8 text-white/80">
            <section>
              <h2 className="text-xl font-bold text-white">1. Who We Are</h2>
              <p className="mt-3 leading-7">
                GalaGo is an event and celebration management platform that helps organizers, couples, teams,
                and guests coordinate invitations, RSVP collection, guest communication, travel details, rooms,
                gifts, photos, and related event operations.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white">2. Information We Collect</h2>
              <p className="mt-3 leading-7">
                We may collect names, email addresses, phone numbers, WhatsApp numbers, event details, RSVP
                responses, room and travel details, uploaded tickets or ID documents, photos, and account or
                login information needed to provide the service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white">3. How We Use Information</h2>
              <p className="mt-3 leading-7">
                We use personal information to operate the platform, manage guest lists, send invitations and
                reminders, support WhatsApp messaging workflows, process RSVPs, enable event logistics,
                personalize guest experiences, provide customer support, improve the product, and maintain
                platform security.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white">4. WhatsApp Communication</h2>
              <p className="mt-3 leading-7">
                If an organizer uses GalaGo to send WhatsApp invitations or event updates, we process recipient
                phone numbers and related message metadata for that purpose. Message delivery and related status
                updates may be processed through Meta and WhatsApp systems. Organizers are responsible for
                ensuring they have the necessary permissions and lawful basis to contact their guests.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white">5. Sharing of Information</h2>
              <p className="mt-3 leading-7">
                We may share data with service providers and infrastructure partners that help us operate the
                platform, such as hosting providers, database providers, storage providers, authentication
                services, analytics tools, and communication platforms including WhatsApp where applicable. We
                do not sell personal information.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white">6. Data Retention</h2>
              <p className="mt-3 leading-7">
                We retain information for as long as needed to provide the service, comply with legal
                obligations, resolve disputes, enforce agreements, and support legitimate business operations.
                Event organizers may also request deletion or update of event-related records, subject to legal
                and operational requirements.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white">7. Security</h2>
              <p className="mt-3 leading-7">
                We take reasonable technical and organizational measures to protect personal information.
                However, no method of transmission or storage is completely secure, and we cannot guarantee
                absolute security.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white">8. Your Choices and Rights</h2>
              <p className="mt-3 leading-7">
                Depending on applicable law, users may have rights to access, correct, delete, or object to the
                processing of personal information. Requests can be sent to the contact email below.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white">9. Children&apos;s Privacy</h2>
              <p className="mt-3 leading-7">
                GalaGo is not intended for children to use independently. If you believe personal information
                relating to a child has been submitted inappropriately, please contact us so we can review the
                request.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white">10. Changes to This Policy</h2>
              <p className="mt-3 leading-7">
                We may update this Privacy Policy from time to time. The updated version will be posted on this
                page with a revised effective date.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white">11. Contact</h2>
              <p className="mt-3 leading-7">
                For privacy questions or requests, contact us at{' '}
                <a className="text-[#FFD93D] hover:text-[#FFE58A]" href="mailto:gogalago.2025@gmail.com">
                  gogalago.2025@gmail.com
                </a>.
              </p>
            </section>
          </div>
        </main>
      </div>
    </div>
  );
}
